module.exports = __webpack_public_path__ + "img/Poland.622b79db.png";